import React from 'react';
import './Ad1.css';

const Ad1 = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (isDevelopment) {
    return (
      <div className="ad-container-dev-1">
        <div className="ad-placeholder-1">
          <p>Advertisement</p>
          <small>300 x 250</small>
        </div>
      </div>
    );
  }

  return (
    <div className="ad-container-1">
      <ins
        className="adsbygoogle-1"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8102084468796250"
        data-ad-slot="7873279252"
        data-ad-format="rectangle"
      />
    </div>
  );
};

export default Ad1; 